import { CategoryOrderBy } from '@data/sdk/match';

export const CategoryOrderByParams = {
  encode(value: any) {
    return value;
  },

  decode(strValue: any): CategoryOrderBy | undefined {
    return strValue;
  },
};
